<template>
  <v-navigation-drawer
    v-model="drawer"
    width="600"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 82vh;">
      <div class="" style="display: flex; width: 100%; padding: 0 5px;">
        <label
          for=""
          v-if="cabecera.opcion1.active"
          class="btn btn-active"
          @click="changeCabecera('GENERAL')"
          >{{ cabecera.opcion1.name }}</label
        >
        <label
          for=""
          v-if="!cabecera.opcion1.active"
          class="btn"
          @click="changeCabecera('GENERAL')"
          >{{ cabecera.opcion1.name }}</label
        >
        <label
          for=""
          v-if="cabecera.opcion2.active && form.is_compuesto == 'true'"
          class="btn btn-active"
          @click="changeCabecera('DETALLE')"
          >{{ cabecera.opcion2.name }}</label
        >
        <label
          for=""
          v-if="!cabecera.opcion2.active && form.is_compuesto == 'true'"
          class="btn"
          @click="changeCabecera('DETALLE')"
          >{{ cabecera.opcion2.name }}</label
        >
        <label
          for=""
          v-if="cabecera.opcion3.active"
          class="btn btn-active"
          @click="changeCabecera('REACTIVO')"
          >{{ cabecera.opcion3.name }}</label
        >
        <label
          for=""
          v-if="!cabecera.opcion3.active"
          class="btn"
          @click="changeCabecera('REACTIVO')"
          >{{ cabecera.opcion3.name }}</label
        >
        <!-- <label
          for=""
          v-if="cabecera.opcion4.active"
          class="btn btn-active"
          @click="changeCabecera('PRECIOS')"
          >{{ cabecera.opcion4.name }}</label
        >
        <label
          for=""
          v-if="!cabecera.opcion4.active"
          class="btn"
          @click="changeCabecera('PRECIOS')"
          >{{ cabecera.opcion4.name }}</label
        > -->
      </div>

      <div
        v-if="cabecera.opcion1.active"
        style="height: 100%; overflow-y: auto;"
      >
        <div style="height:33%;" class="pt-4">
          <v-row class="pl-3 pr-3">
            <v-col cols="6" class="pt-3 pb-3">
              <v-text-field
                ref="code"
                v-model="form.code"
                :value="form.code"
                label="Codigo"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pt-3 pb-3">
              <v-text-field
                ref="name"
                v-model="form.name"
                :value="form.name"
                label="Nombre"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pl-3 pr-3">
            <v-col cols="6">
              <v-autocomplete
                v-model="form.area_id"
                :items="areas"
                label="Area"
                hide-details
                outlined
                :item-text="customText"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="form.unit_medida_id"
                :items="units"
                label="Unidad de Medida"
                hide-details
                outlined
                :item-text="customText"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- <v-row class="pl-3 pr-3">
            <v-col cols="6" class="pt-3 pb-3">
              <v-text-field
                ref="descripcion1"
                v-model="form.description1"
                :value="form.description1"
                label="Descripcion 1"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pt-3 pb-3">
              <v-text-field
                ref="descripcion2"
                v-model="form.description2"
                :value="form.description2"
                label="Descripcion 2"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row class="pl-3 pr-3">
            <v-col cols="4" class="pt-3 pb-3">
              <v-text-field
                ref="base_price"
                v-model="form.base_price"
                :value="form.base_price"
                label="Precio Base"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="4" class="pt-3 pb-3">
              <v-text-field
                ref="convenio_price"
                v-model="form.convenio_price"
                :value="form.convenio_price"
                label="Precio Convenio"
                outlined
                hide-details
              ></v-text-field>
            </v-col> -->
            <v-col cols="3" class="" style="padding-top:0px; ">
              <label>Compuesto</label>
              <v-btn-toggle
                v-model="form.is_compuesto"
                :value="form.is_compuesto"
                mandatory
                dense
                color="green darken-3"
                @change="handleTypeDinamic()"
                class="float-right"
              >
                <v-btn value="true" class="btn-show-mode" style="height:28px; ">
                  SI
                </v-btn>
                <v-btn
                  value="false"
                  class="btn-show-mode"
                  style="height:28px; "
                >
                  NO
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="3" class="" style="padding-top:0px; ">
              <label>Descripcion</label>
              <v-btn-toggle
                v-model="form.is_description"
                :value="form.is_description"
                mandatory
                dense
                color="green darken-3"
                class="float-right"
              >
                <v-btn value="true" class="btn-show-mode" style="height:28px; ">
                  SI
                </v-btn>
                <v-btn
                  value="false"
                  class="btn-show-mode"
                  style="height:28px; "
                >
                  NO
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>

          <v-row class="pl-3 pr-3">
            <v-col cols="6" class="pt-2 pb-3">
              <v-text-field
                ref="tiempo_entrega"
                v-model="form.tiempo_entrega"
                :value="form.tiempo_entrega"
                label="Tiempo de Entrega"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pt-2 pb-3">
              <v-text-field
                ref="preanalitica"
                v-model="form.preanalitica"
                :value="form.preanalitica"
                label="Condiciones Preanalitica"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-row
          class="pl-3 pr-3 "
          style="height: 28%; margin-top:80px;"
          v-if="form.is_compuesto == 'false'"
        >
          <vue-editor
            class="table-editor"
            v-model="form.content"
            placeholder="Rango Referencial"
          ></vue-editor>
        </v-row>

        <v-row
          class="pl-3 pr-3 "
          style="height: 28%; opacity: 0.5; margin-top:80px;"
          v-if="form.is_compuesto == 'true'"
        >
          <vue-editor
            class="table-editor"
            disabled="true"
            v-model="form.content"
            placeholder="Rango Referencial"
          ></vue-editor>
        </v-row>

        <v-row
          class="pl-3 pr-3 "
          style="height: 10%; margin-top:130px;"
          v-if="form.is_description == 'true'"
        >
          <vue-editor
            class="table-editor"
            v-model="form.description1"
            placeholder="Descripcion 1"
          ></vue-editor>
        </v-row>

        <v-row
          class="pl-3 pr-3 "
          style="height: 10%; margin-top:240px;"
          v-if="form.is_description == 'true'"
        >
          <vue-editor
            class="table-editor"
            v-model="form.description2"
            placeholder="Descripcion 2"
          ></vue-editor>
        </v-row>

        <!-- <div class="pl-3 pt-3 pr-3" style="height: 25vh; background: #66FF66;"> -->
      </div>

      <div v-if="cabecera.opcion2.active" style="height: 100%">
        <div class="pl-3 pt-4 pr-3" style="height:06%;">
          <v-row
            class="pl-3 pr-3"
            style="display: flex; width: 100%; justify-content: center;"
          >
            <v-btn
              v-if="form.is_compuesto == 'false'"
              class="btn-analisis"
              style=""
            >
              Agregar analisis al detalle
            </v-btn>
            <v-btn
              v-if="form.is_compuesto == 'true'"
              class="btn-analisis btn-analisis-active"
              style=""
              @click="handleShowAddAnalysisDetail"
            >
              Agregar analisis al detalle
            </v-btn>
          </v-row>
        </div>
        <label
          for=""
          style="display:flex; padding:35px 5px 2px; font-weight:900;"
        >
          Examenes Agregados ( {{ cant_analisis }} )</label
        >
        <draggable
          class="dragArea"
          v-model="dataExamenes"
          :options="{ group: 'dataExamenes' }"
          style="height: 35rem; overflow: auto;"
        >
          <div
            v-for="(item, indice) of dataExamenes"
            :key="indice"
            style="padding:5px 5px; "
          >
            <div style="padding:5px 5px;" v-if="!item.delete">
              <v-card
                elevation="2"
                style="padding:10px 15px; display: flex; justify-content:space-between; width:100%;"
              >
                <div style="display: flex; flex-direction: column;">
                  <label for="" style="font-weight:900;">{{ item.name }}</label>
                  <div
                    v-for="(itemDetailRank,
                    indice) of item.rango_referencial_detail"
                    :key="indice"
                  >
                    <label for="" style="font-size: 13px;">{{
                      itemDetailRank
                    }}</label>
                  </div>
                  <!-- <div>
                    {{ item.rango_referencial_aux }}
                  </div> -->
                  <!-- <label for=""> {{ item.rango_referencial_aux }}</label> -->
                </div>
                <div style="display: flex;">
                  <div class="div-unidad">
                    <label for="">{{
                      item.unidadMedida ? item.unidadMedida.name : ""
                    }}</label>
                    <label v-if="item.is_dinamic == 'true'" for="">-</label>
                    <label v-if="item.is_dinamic == 'true'" for=""
                      >Dinamico</label
                    >
                    <!-- <label v-if="!item.is_dinamic" for=""></label> -->
                  </div>
                  <v-btn
                    icon
                    small
                    dark
                    color="red"
                    @click="handleDeleteAnalysis(item, indice)"
                  >
                    <v-icon size="14">far fa-times-circle</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </div>
        </draggable>
      </div>

      <div v-if="cabecera.opcion3.active" style="height: 100%">
        <v-row class="pl-3 pr-3">
          <v-col cols="8">
            <v-autocomplete
              v-model="form_reactivo.material_id"
              ref="material_id"
              :items="inventories"
              label="Reactivo"
              outlined
              :item-text="customTextDescription"
              item-value="id"
              clearable
              :value="form_reactivo.material_id"
              :loading="isLoading"
              v-on:keyup.enter="searchReactivos($event)"
              hide-details="auto"
              required
            ></v-autocomplete>
            <!-- <v-autocomplete
              v-model="form_reactivo.material_id"
              :items="inventories"
              label="Reactivo"
              hide-details
              outlined
              :item-text="customTextDescription"
              item-value="id"
              clearable
            ></v-autocomplete> -->
          </v-col>
          <v-col cols="4" class="pt-3 pb-3">
            <v-text-field
              ref="cantidad"
              :value="form_reactivo.cantidad"
              v-model="form_reactivo.cantidad"
              label="Cantidad"
              outlined
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <div class="pl-3 pt-3 pr-3">
          <v-row
            class="pl-3 pr-3"
            style="display: flex; width: 100%; justify-content: center;"
          >
            <button
              class="btn-analisis btn-analisis-active btn-reactivo"
              style=""
              @click="handleAddReactivo()"
            >
              Agregar Reactivo
            </button>
          </v-row>
        </div>
        <div class="line"></div>
        <div
          style="display:flex; justify-content:space-between; align-items:center; padding-top:10px;"
        >
          <label for="" style="display:flex; font-weight:900;"
            >{{ cant_reactivos }} Reactivos Agregados</label
          >
          <div style="display:flex; flex-direction:column; margin-right:40px;">
            <label>Sucursales (*)</label>
            <v-btn-toggle
              v-model="form.is_reactivo_global"
              :value="form.is_reactivo_global"
              mandatory
              dense
              color="green darken-3"
              @change="handleTypeDinamic()"
              class="float-right"
            >
              <v-btn value="true" class="btn-show-mode" style="height:28px; ">
                SI
              </v-btn>
              <v-btn value="false" class="btn-show-mode" style="height:28px; ">
                NO
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>

        <div
          v-for="(item, indice) of dataReactivos"
          :key="indice"
          style="padding:5px 5px;"
        >
          <div style="padding:5px 5px;" v-if="!item.delete">
            <v-card
              elevation="2"
              style="padding:10px 15px; display: flex; justify-content:space-between; width:100%;"
            >
              <div style="display: flex; flex-direction: column;">
                <label for="" style="font-weight:900;">{{
                  item.description
                }}</label>
                <label for="">Cantidad: {{ item.cantidad }}</label>
              </div>
              <div style="display: flex;">
                <div class="div-unidad">
                  <label for="" style="">{{ item.unit_name }}</label>
                </div>
                <v-btn
                  icon
                  small
                  dark
                  color="red"
                  @click="handleDeleteReactivo(item, indice)"
                >
                  <v-icon size="14">far fa-times-circle</v-icon>
                </v-btn>
              </div>
            </v-card>
          </div>
        </div>
      </div>

      <div v-if="cabecera.opcion4.active" style="height:100%">
        <div style="">
          <v-row class="pl-3 pr-3">
            <v-col cols="8">
              <v-autocomplete
                v-model="form_prices.company_id"
                :items="companies"
                label="Compañias"
                hide-details
                outlined
                :item-text="customTextDescriptionCompanies"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" class="pt-3 pb-3">
              <v-text-field
                ref="price"
                :value="form_prices.price"
                v-model="form_prices.price"
                label="Cantidad"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="pl-3 pt-3 pr-3">
            <v-row
              class="pl-3 pr-3"
              style="display: flex; width: 100%; justify-content: center;"
            >
              <button
                class="btn-analisis btn-analisis-active btn-reactivo"
                style=""
                @click="handleAddPrices()"
              >
                Agregar Precio
              </button>
            </v-row>
          </div>
          <div class="line"></div>

          <div
            v-for="(item, indice) of dataPrices"
            :key="indice"
            style="padding:5px 5px;"
          >
            <div style="padding:5px 5px;" v-if="!item.delete">
              <v-card
                elevation="2"
                style="padding:10px 15px; display: flex; justify-content:space-between; width:100%;"
              >
                <div style="display: flex; flex-direction: column;">
                  <label for="" style="font-weight:900;">{{ item.name }}</label>
                  <label for="">S/. {{ item.price }}</label>
                </div>
                <div style="display: flex;">
                  <v-btn
                    icon
                    small
                    dark
                    color="blue"
                    @click="handleEditPrice(item, indice)"
                  >
                    <v-icon size="14">fa-regular fa-pen-to-square</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    dark
                    color="red"
                    @click="handleDeletePrices(item, indice)"
                  >
                    <v-icon size="14">far fa-times-circle</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
    <add-analysis-detail
      ref="addAnalysisDetail"
      :devolver-data="handleAddAnalysis"
    ></add-analysis-detail>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import AddAnalysisDetail from "./AddAnalysisDetail";
import draggable from "vuedraggable";

export default {
  name: "CreateUpdate",
  components: {
    VueEditor,
    AddAnalysisDetail,
    draggable,
  },
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      is_compuesto: "false",
      cant_reactivos: 0,
      cant_analisis: 0,
      cabecera: {
        opcion1: {
          name: "GENERAL",
          active: true,
          class: "",
        },
        opcion2: {
          name: "DETALLE",
          active: false,
          class: "",
        },
        opcion3: {
          name: "REACTIVO",
          active: false,
          class: "",
        },
        opcion4: {
          name: "PRECIOS",
          active: false,
          class: "",
        },
      },
      form: {
        id: null,
        name: null,
        code: null,
        area_id: null,
        unit_medida_id: null,
        base_price: null,
        convenio_price: null,
        is_compuesto: "false",
        content: null,
        is_reactivo_global: "false",
        description1: null,
        description2: null,
        is_description: "false",
        tiempo_entrega: "",
        preanalitica: "",
      },
      form_reactivo: {
        material_id: null,
        cantidad: null,
      },
      form_prices: {
        company_id: null,
        price: null,
      },
      content: "",
      dataReactivos: [],
      dataExamenes: [],
      dataPrices: [],
      items: [
        {
          id: 0,
          name: "Item A",
          list: 1,
        },
        {
          id: 1,
          name: "Item B",
          list: 1,
        },
        {
          id: 2,
          name: "Item C",
          list: 2,
        },
      ],
      isLoading: false,
    };
  },
  computed: {
    ...mapState("areas", ["areas"]),
    ...mapState("units", ["units"]),
    ...mapState("reactive", ["inventories"]),
    ...mapState("companies", ["companies"]),
  },
  methods: {
    ...mapActions("areas", ["setForm", "getAreas"]),
    ...mapActions("analysis", [
      "getAnalysis",
      "store",
      "update",
      "delete",
      "change_status",
    ]),
    ...mapActions("units", ["getUnits"]),
    ...mapActions("material", ["getMaterialAll"]),
    ...mapActions("reactive", ["getReactiveAll"]),
    ...mapActions("companies", ["getCompanies"]),
    customText(item) {
      let text = item.name;
      return text;
    },

    customTextDescription(item) {
      let text = item.description;
      return text;
    },
    customTextDescriptionCompanies(item) {
      let text = item.name;
      return text;
    },

    async showForm(title, action, analysis = null) {
      this.clearData();
      this.titleForm = title;
      this.action = action;
      if (analysis) {
        // console.log("actualizar", analysis);
        // this.setArea(analysis);
        this.parseDataForUpdate(analysis);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      // ! limpiar data
      this.titleForm = null;
      this.action = null;

      this.form = {
        id: null,
        name: null,
        code: null,
        area_id: null,
        unit_medida_id: null,
        base_price: null,
        convenio_price: null,
        is_compuesto: "false",
        content: null,
        is_reactivo_global: "false",
        description1: null,
        description2: null,
        is_description: "false",
        preanalitica: "",
        tiempo_entrega: "",
      };

      this.dataExamenes = [];
      this.dataReactivos = [];
      this.dataPrices = [];
      this.cant_reactivos = 0;
      this.cant_analisis = 0;

      this.cabecera.opcion1.active = true;
      this.cabecera.opcion2.active = false;
      this.cabecera.opcion3.active = false;
      this.cabecera.opcion4.active = false;

      this.form_reactivo.material_id = null;
      this.form_reactivo.cantidad = null;
      this.form_prices.company_id = null;
      this.form_prices.price = null;

      this.clearErrors();
    },
    setArea(area) {
      this.form.id = area.id;
      this.form.name = area.name;
    },
    closeForm() {
      // this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },

    async handleStore() {
      const sendForm = this.parseData();
      await this.store(sendForm);
      // if (!this.existErrors()) {
      //   this.closeForm();
      // }
    },
    parseData() {
      const { area_id, base_price, description1, description2 } = this.form;
      const { is_description, tiempo_entrega, preanalitica } = this.form;
      const { code, convenio_price, is_reactivo_global } = this.form;
      const { is_compuesto, name, unit_medida_id, content, id } = this.form;
      const reactivos = this.dataReactivos;
      const subAnalisis = this.dataExamenes.map((exam, index) => {
        return { ...exam, index };
      });
      const prices = this.dataPrices.map((dtp) => {
        return {
          company_id: dtp.company_id,
          price: dtp.price,
          delete: dtp.delete,
          ruc: dtp.ruc,
          active: dtp.active,
          name: dtp.name,
          id: dtp.id,
        };
      });
      return {
        id,
        area_id,
        base_price,
        code,
        convenio_price,
        is_compuesto,
        name,
        unit_medida_id,
        content,
        is_reactivo_global,
        reactivos,
        subAnalisis,
        prices,
        description1,
        description2,
        is_description,
        tiempo_entrega,
        preanalitica,
      };
    },
    async handleUpdate() {
      const sendForm = this.parseData();
      // console.log(sendForm);
      await this.update(sendForm);

      //   if (!this.existErrors()) {
      //     const { id, name } = this.form;
      //     await this.update({ id, name });
      //     this.closeForm();
      //   }
    },
    // ! activar agregar analisis detalle
    handleTypeDinamic() {},

    changeCabecera(value) {
      // btn-active
      if (value == "GENERAL") {
        this.cabecera.opcion1.active = true;
        this.cabecera.opcion2.active = false;
        this.cabecera.opcion3.active = false;
        this.cabecera.opcion4.active = false;
      }
      if (value == "DETALLE") {
        this.cabecera.opcion1.active = false;
        this.cabecera.opcion2.active = true;
        this.cabecera.opcion3.active = false;
        this.cabecera.opcion4.active = false;
      } else if (value == "REACTIVO") {
        this.cabecera.opcion1.active = false;
        this.cabecera.opcion2.active = false;
        this.cabecera.opcion3.active = true;
        this.cabecera.opcion4.active = false;
      } else if (value == "PRECIOS") {
        this.cabecera.opcion1.active = false;
        this.cabecera.opcion2.active = false;
        this.cabecera.opcion3.active = false;
        this.cabecera.opcion4.active = true;
      }
      // console.log("changeCabecera:::>", value, this.cabecera);
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    handleAddReactivo() {
      const { material_id, cantidad } = this.form_reactivo;
      if (material_id == null || cantidad == null) return;
      const item = this.inventories.find((i) => i.id == material_id);
      const newItem = { ...item, cantidad, id: null, delete: false };
      // console.log("nuevo item =>>>", newItem);
      const returnItem = this.dataReactivos.find(
        (dt) => dt.product_id == newItem.product_id
      );
      if (returnItem) {
        this.dataReactivos = this.dataReactivos.map((dt) =>
          dt.product_id == newItem.product_id ? newItem : dt
        );
      } else {
        this.dataReactivos = [...this.dataReactivos, newItem];
      }
      this.form_reactivo.cantidad = null;
      this.form_reactivo.material_id = null;
      this.cant_reactivos = this.countItems(this.dataReactivos);
    },
    handleDeleteReactivo(item, newIndex) {
      // this.dataReactivos = this.dataReactivos.filter((dt) => dt.id != item.id);

      // this.dataReactivos = this.dataReactivos.map((dt) =>{
      //   if(dt.id == item.id){
      //     dt.delete = true;
      //   }
      //   return dt
      // })
      const newArray = [];
      for (let i = 0; i < this.dataReactivos.length; i++) {
        // if (i != newIndex) {
        //   newArray.push(this.dataExamenes[i]);
        // }
        if (i == newIndex) {
          this.dataReactivos[i].delete = true;

          newArray.push({ ...this.dataReactivos[i] });
        } else {
          newArray.push(this.dataReactivos[i]);
        }
      }

      this.dataReactivos = newArray;
      // this.cant_reactivos = this.dataReactivos.length;
      this.cant_reactivos = this.countItems(this.dataReactivos);
    },
    handleAddPrices() {
      const { company_id, price } = this.form_prices;
      if (company_id == null || price == null) return;

      const item = this.companies.find((i) => i.id == company_id);
      const returnItem = this.dataPrices.find((dt) => dt.company_id == item.id);

      let newItem = {
        ...item,
        price,
        delete: false,
        company_id: item.id,
      };

      if (returnItem) {
        // ? actualiza el item
        newItem = { ...newItem, id: returnItem.id };
        this.dataPrices = this.dataPrices.map((dt) =>
          dt.id == newItem.id ? newItem : dt
        );
      } else {
        // ? crea un nuevo item
        newItem = { ...newItem, id: null };
        this.dataPrices = [...this.dataPrices, newItem];
      }

      this.form_prices.price = null;
      this.form_prices.company_id = null;
    },
    handleEditPrice(item, newIndex) {
      // console.log("modificar precio ===>>>>> ", item);
      this.form_prices.price = item.price;
      this.form_prices.company_id = item.company_id;
    },
    handleDeletePrices(item, newIndex) {
      const newArray = [];
      for (let i = 0; i < this.dataPrices.length; i++) {
        if (i == newIndex) {
          this.dataPrices[i].delete = true;
          newArray.push({ ...this.dataPrices[i] });
        } else {
          newArray.push(this.dataPrices[i]);
        }
      }
      this.dataPrices = newArray;
    },
    handleAddAnalysis(item) {
      this.dataExamenes.push({
        ...item,
        id: null,
        delete: false,
        rango_referencial_detail: this.filterEtiquetas(item.rango_referencial),
      });

      this.cant_analisis = this.countItems(this.dataExamenes);
    },
    handleDeleteAnalysis(item, newIndex) {
      const newArray = [];
      for (let i = 0; i < this.dataExamenes.length; i++) {
        // if (i != newIndex) {
        //   newArray.push(this.dataExamenes[i]);
        // }
        if (i == newIndex) {
          newArray.push({ ...this.dataExamenes[i], delete: true });
        } else {
          newArray.push(this.dataExamenes[i]);
        }
      }
      this.dataExamenes = newArray;
      this.cant_analisis = this.countItems(newArray);

      // console.log(newArray)
      // this.dataExamenes = this.dataExamenes.filter((item, index)=> index != newIndex)
      // console.log(item, index);
    },

    handleShowAddAnalysisDetail() {
      this.getAllService();
      this.$refs.addAnalysisDetail.showDialog();
    },
    parseDataForUpdate(item) {
      const newDetail = [];
      const newServiceProduct = [];
      let bandReactivos = false;
      this.form = {
        id: item.id,
        name: item.name,
        code: item.code,
        area_id: item.specialized_id,
        unit_medida_id: item.unit_id,
        base_price: Number(item.base_price),
        convenio_price: Number(item.monto_convenio),
        is_compuesto: item.iscompound == "on " ? "true" : "false",
        content: item.rank,
        is_reactivo_global: "false",
        description1: item.description1,
        description2: item.description2,
        is_description: item.is_description ? "true" : "false",
        tiempo_entrega: item.tiempo_entrega,
        preanalitica: item.preanalitica,
      };
      // console.log(this.form);
      //   this.dataExamenes = item.detail
      //   this.dataReactivos = item.service_product
      // console.log(item.service_product);
      item.detail.map((dt) => {
        const findUnidad = this.units.find((ut) => ut.id == dt.unit_id);
        newDetail.push({
          id: dt.id,
          service_id: dt.service_id,
          name: dt.name,
          unit_id: dt.unit_id,
          rango_referencial: dt.rank,
          rango_referencial_detail: this.filterEtiquetas(dt.rank),
          code: dt.code,
          is_dinamic: dt.dinamic == "on " ? "true" : "false",
          index: dt.index,
          unidadMedida: findUnidad,
          delete: false,
          is_compuesto: dt.is_compuesto,
          service_id_reference: dt.services_id_reference,
        });
      });
      item.service_product.map((sp) => {
        newServiceProduct.push({
          id: sp.id,
          service_id: sp.service_id,
          quantity: sp.quantity,
          unit_id: sp.unit_id,
          active: sp.active,
          product_id: sp.product_id,
          cant_pruebas: sp.cant_pruebas,
          office_id: sp.office_id,
          cantidad: sp.cant_pruebas,
          description: sp?.product?.description,
          unit_name: sp?.product?.unit?.name,
          delete: false,
        });
        if (!bandReactivos && sp.office_id == null) bandReactivos = true;
      });
      this.dataExamenes = newDetail;
      this.dataReactivos = newServiceProduct;
      // console.log("dataExamenes", newDetail);
      // console.log("dataReactivos", newServiceProduct);
      this.dataPrices = item.detail_price.map((dtp) => {
        dtp.delete = false;
        return dtp;
      });
      this.cant_reactivos = this.dataReactivos.length;
      this.cant_analisis = this.countItems(this.dataExamenes);
      this.form.is_reactivo_global = bandReactivos ? "true" : "false";
    },

    countItems(value) {
      let count = 0;
      if (value.length > 0) {
        value?.map((v) => {
          if (!v.delete) count++;
        });
      }
      return count;
    },
    filterEtiquetas(value) {
      const newDetail = [];
      if (value == null) return;
      const filter01 = value.replace(/<p>/g, "");
      // const filter02 = filter01.replace(/<\/p>/g, " " + " ");
      const parts = filter01.split("</p>");
      parts.map((item) => {
        if (item.length > 0) newDetail.push(item);
      });
      // return filter02;
      return newDetail;
    },
    async searchReactivos(event) {
      this.isLoading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getReactiveAll({ description: value });
      } else {
        await this.getReactiveAll();
      }
      this.isLoading = false;
    },
    async getAllService() {
      await this.getAnalysis();
    },
  },

  created() {
    this.getAreas();
    this.getUnits();

    // this.getMaterialAll();
    this.getReactiveAll();
    this.getCompanies();
  },
  mounted() {},
};
</script>

<style scoped>
.btn {
  display: flex;
  width: 50%;
  justify-content: center;
  border-bottom: 2px solid #aaaaaa;
  padding-bottom: 5px;
  font-weight: 700;
  font-size: 1.3rem;
  color: #aaaaaa;
}
.btn-active {
  color: black;
  border-color: #5045e6;
}
.btn:hover {
  background-color: #eeeeee;
}

.table-editor {
  height: 200px;
  width: 575px;
}

.btn-analisis {
  border-radius: 23px;
  padding: 0.5rem 2rem;
  background-color: #eeeeee;
  color: #aaaaaa;
  font-weight: 600;
}
.btn-analisis-active {
  color: #5045e6;
}

.line {
  height: 2px;
  width: 100%;
  background-color: #dddddd;
  margin-top: 17px;
}

.div-unidad {
  background-color: #dddddd;
  height: 25px;
  padding: 0 18px;
  border-radius: 10px;
  margin-right: 5px;
}

.btn-reactivo:hover {
  background-color: #c0bcff;
}
.btn-analisis-active:hover {
  background-color: #c0bcff;
}

.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}
.drag-el {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}

.ql-container {
  background-color: #5045e6;
  min-height: 30px !important;
}
/* #responsibilityEdit .ql-editor {
  min-height: 200px;
  background-color: #5045e6;
} */
</style>
